/**
 * Set of various ATBase events like login, logout, tool switch etc.
 */
export const AssociateToolsBaseEventBusTopics = {
    SET_WAKE_BUTTON_STATE: 'associateToolsBase:set-wake-button-state',
    WAKE_BUTTON_CLICKED: 'associateToolsBase:wake-button-clicked',
    LOGOUT: 'associateToolsBase:logout',
    LOGIN: 'associateToolsBase:login',
    LOGOUT_ACTION: 'associateToolsBase:logout-action',
    TOOL_SWITCH: 'associateToolsBase:tool-switch',
    HIDE_MENU: 'associateToolsBase:hide-menu',
    SHOW_NOTIFICATION_MODAL: 'associateToolsBase:show-notification-modal',
    PUSH_NOTIFICATION_EVENT: 'associateToolsBase:push-notification-event',
    DISPLAY_BLUETOOTH_PAIRING_MODAL: 'associateToolsBase:display-bluetooth-pairing-modal',
    BLUETOOTH_PAIRING_MODAL_RESULT: 'associateToolsBase:bluetooth-pairing-modal-result',
}
